import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    width: '100%',
    height: '100%',
  },
  formWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    width: '100%',
    height: '100%',
    fontSize: '1.2rem',
    '& h3': {
      fontSize: '1.75rem',
    },
    '& p > span': {
      fontWeight: 600,
    },
  },

  formLayout: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '2.5rem',
    padding: '1rem',
    width: '100%',
    animation: `$fadeIn 1000ms ease-in-out`,
  },
  
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  formColumn: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem 1.5rem',
    width: '100%',
    minHeight: '300px ',
    borderRadius: 5,
    boxShadow: '1px 1px 3px 1px rgba(0,0,0,.25)',
  },

  formFields: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '75%',
    gap: '0.25rem',
    marginTop: '1.25rem',
  },
}))

export default styles
